export type IAgFormThirdSectionInterface = {
    AuthorizedRepresentativeType?: string;
    AuthorizedRepresentativeTypeOther?: string;
    RepresentativeName?: string;
    RepresentativeTitle?: string;
    RepresentativePhoneNumber?: string;
    RepresentativeEmailAddress?: string;
    RepresentativeMailingAddressLine1?: string;
    RepresentativeMailingAddressLine2?: string;
    RepresentativeMailingAddressCity?: string;
    RepresentativeMailingAddressState?: string;
    RepresentativeMailingAddressZip?: string;
}

export const AgFormThirdSectionInitialState = () => ({
    AuthorizedRepresentativeType: undefined,
    AuthorizedRepresentativeTypeOther: undefined,
    RepresentativeName: undefined,
    RepresentativeTitle: undefined,
    RepresentativePhoneNumber: undefined,
    RepresentativeEmailAddress: undefined,
    RepresentativeMailingAddressLine1: undefined,
    RepresentativeMailingAddressLine2: undefined,
    RepresentativeMailingAddressCity: undefined,
    RepresentativeMailingAddressState: undefined,
    RepresentativeMailingAddressZip: undefined
})